import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function ZdrojEditaceWidgetTitleDescription({ zdroj, loading }) {
  const message = useServerMessage();
  const { titleNew } = useMessages();

  const popis = message(zdroj, "popis");
  return loading ? (
    <PlaceholderText>
      <span className="b2b-ZakaznikDetail-description">
        VZO (lorem ipsum dolor)
      </span>
    </PlaceholderText>
  ) : zdroj ? (
    <>
      {`${message(zdroj, "nazev")}`}
      {popis ? ` ( ${popis} )` : ""}
    </>
  ) : (
    titleNew()
  );
}

ZdrojEditaceWidgetTitleDescription.propTypes = {
  loading: T.bool,
  zdroj: T.object
};

export default React.memo(ZdrojEditaceWidgetTitleDescription);
